import { ResourceCalendar } from '@/components/calendar/ResourceCalendar';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import { WhatIfScenario } from '@/types';

interface DashboardProps {
  heatmapMode?: boolean;
  /** Scenario handed off from the heatmap suggestions panel — calendar opens in what-if mode */
  whatIfScenario?: WhatIfScenario | null;
  /** Called when the user commits or discards a what-if scenario */
  onWhatIfComplete?: (navigateBackToHeatmap?: boolean) => void;
  /** Heatmap-mode only: called when Apply/Assign is pressed in the suggestions panel */
  onNavigateToCalendarWithWhatIf?: (scenario: WhatIfScenario) => void;
}

export function Dashboard({
  heatmapMode = false,
  whatIfScenario,
  onWhatIfComplete,
  onNavigateToCalendarWithWhatIf,
}: DashboardProps) {
  return (
    // h-full + overflow-hidden: fills the flex-1 main area and prevents
    // this container from generating its own scrollbar — Bryntum Scheduler
    // manages all scrolling internally.
    <div className="h-full overflow-hidden">
      <ErrorBoundary>
        <ResourceCalendar
          initialHeatmapMode={heatmapMode}
          whatIfScenario={whatIfScenario}
          onWhatIfComplete={onWhatIfComplete}
          onNavigateToCalendarWithWhatIf={onNavigateToCalendarWithWhatIf}
        />
      </ErrorBoundary>
    </div>
  );
}
